import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { Cart } from '@/lib/ecwid/ecwidTypes';

export type CartState = {
    cart: Cart | undefined;
    setCart: (cart: Cart | undefined) => void;
    cartOpen: boolean;
    setCartOpen: (cartOpen: boolean) => void;
};

export const useCartStore = create<CartState>()(
    devtools(
        persist(
            set => ({
                cart: undefined,
                setCart: cart => set({ cart }),
                cartOpen: false,
                setCartOpen: (cartOpen: boolean) => set({ cartOpen }),
            }),
            {
                name: 'cart-storage',
                partialize: state => ({ cart: state.cart }),
            },
        ),
    ),
);
